module.exports = __webpack_public_path__ + "static/img/egg_title.dffc369.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/egg_title.png
// module id = H7rM
// module chunks = 1